import React from 'react'
import NoImageAvailable from './images/noImageAvailable.jpeg'
import './SelectYourLocation.css'
import { GpButton, GpImagePlaceholder } from '../../components/gp'

const PropertyCard = (props) => {
    const heroUrl = props.propertyInfo?.hero?.[2]?.url
    const name = props.propertyInfo?.name || 'Property'
    const address = props.propertyInfo?.address
    const addressLine =
        address &&
        [
            address.streetAddress || address.line1,
            [address.city, address.state].filter(Boolean).join(', '),
        ]
            .filter(Boolean)
            .join(' · ')
    const evReady = !!props.propertyInfo?.acceptingMembers
    const portCount =
        props.propertyInfo?.numberOfPorts ||
        props.propertyInfo?.numberOfPowerPorts ||
        props.propertyInfo?.powerPortCount

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                padding: '14px 16px',
                borderBottom: props.isLast
                    ? 'none'
                    : '1px solid var(--gp-hairline)',
            }}
        >
            <div style={{ width: 88, height: 64, flexShrink: 0 }}>
                {heroUrl ? (
                    <img
                        alt="propertyImg"
                        src={heroUrl}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 'var(--gp-r-md)',
                            display: 'block',
                        }}
                    />
                ) : props.propertyInfo?.hero === undefined ? (
                    <GpImagePlaceholder
                        label="property photo"
                        aspect="88 / 64"
                        style={{ width: '100%', height: '100%' }}
                    />
                ) : (
                    <img
                        alt="propertyImg"
                        src={NoImageAvailable}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 'var(--gp-r-md)',
                            display: 'block',
                        }}
                    />
                )}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
                <div
                    style={{
                        font: 'var(--gp-body-med)',
                        color: 'var(--gp-ink)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {name}
                </div>
                {addressLine && (
                    <div
                        style={{
                            font: 'var(--gp-caption)',
                            color: 'var(--gp-ink-mute)',
                            marginTop: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {addressLine}
                    </div>
                )}
                <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                    {evReady && (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 6,
                                padding: '3px 10px',
                                borderRadius: 999,
                                background: 'var(--gp-lime-soft)',
                                color: 'var(--gp-brand)',
                                font: 'var(--gp-micro)',
                                letterSpacing: 0.3,
                            }}
                        >
                            <span
                                style={{
                                    width: 5,
                                    height: 5,
                                    borderRadius: '50%',
                                    background: 'var(--gp-brand)',
                                }}
                            />
                            EV ready
                        </span>
                    )}
                    {portCount > 0 && (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '3px 10px',
                                borderRadius: 999,
                                background: 'var(--gp-info-soft)',
                                color: 'var(--gp-info)',
                                font: 'var(--gp-micro)',
                                letterSpacing: 0.3,
                            }}
                        >
                            {portCount} EV charger{portCount > 1 ? 's' : ''}
                        </span>
                    )}
                </div>
            </div>

            <GpButton
                variant="primary"
                onClick={() =>
                    props.selectThisProperty(props.propertyInfo, props.propertyCardIndex)
                }
                disabled={props.disableSelect}
                style={{ height: 36, padding: '0 16px', fontSize: 13, flexShrink: 0 }}
            >
                {props.selectedPropertyIndex === props.propertyCardIndex
                    ? 'Selected'
                    : 'Select'}
            </GpButton>
        </div>
    )
}

export default PropertyCard
